const GET_CONTRIBUTION_PERFORMANCE_VS_BUDGET_REQUEST = "spark/customer/insights/performance/budget/contributionVsBudget/GET_CONTRIBUTION_PERFORMANCE_VS_BUDGET_REQUEST";
const GET_CONTRIBUTION_PERFORMANCE_VS_BUDGET_SUCCESS = "spark/customer/insights/performance/budget/contributionVsBudget/GET_CONTRIBUTION_PERFORMANCE_VS_BUDGET_SUCCESS";
const GET_CONTRIBUTION_PERFORMANCE_VS_BUDGET_FAILURE = "spark/customer/insights/performance/budget/contributionVsBudget/GET_CONTRIBUTION_PERFORMANCE_VS_BUDGET_FAILURE";

const types = {
    GET_CONTRIBUTION_PERFORMANCE_VS_BUDGET_REQUEST,
    GET_CONTRIBUTION_PERFORMANCE_VS_BUDGET_SUCCESS,
    GET_CONTRIBUTION_PERFORMANCE_VS_BUDGET_FAILURE
};

export default types;
